module.exports = __webpack_public_path__ + "img/04.9ac13dd0.png";